const mapGraphedGroups = (groups) =>
    groups
        .filter((group) => group?.tags?.length)
        .map((group) => ({
            label: group.name,
            items: (group.tags || [])
                .filter((tag) => tag?.id && tag?.name)
                .map((tag) => ({ label: tag.name, value: tag.id })),
        }));

export const buildGroupedTagOptionsFromGraphed = (tagGroupsGraphed) => {
    if (!tagGroupsGraphed?.groups?.length) {
        return [];
    }
    return mapGraphedGroups(tagGroupsGraphed.groups);
};

const getTagGroupId = (tag) => tag?.group?.id ?? tag?.groupId;

export const buildGroupedTagOptionsFromFlat = (tagGroups, tags) => {
    const groups = Array.isArray(tagGroups) ? tagGroups : [];
    const tagList = Array.isArray(tags) ? tags : [];

    if (!groups.length || !tagList.length) {
        return [];
    }

    return groups
        .filter((group) => group?.id && group?.name)
        .map((group) => ({
            label: group.name,
            items: tagList
                .filter((tag) => {
                    const groupId = getTagGroupId(tag);
                    return groupId != null && String(groupId) === String(group.id);
                })
                .filter((tag) => tag?.id && tag?.name)
                .map((tag) => ({ label: tag.name, value: tag.id })),
        }))
        .filter((group) => group.items.length > 0);
};

export const buildGroupedTagOptions = (tagGroupsGraphed, tagGroups, tags) => {
    const fromGraphed = buildGroupedTagOptionsFromGraphed(tagGroupsGraphed);
    if (fromGraphed.length) {
        return fromGraphed;
    }
    return buildGroupedTagOptionsFromFlat(tagGroups, tags);
};
